import setAppSettingsForTeam from "../actions/setAppSettingsForTeam";
import { FlightSettingsPollingService } from "sh-services";
import { orchestrator } from "satcheljs";

export default orchestrator( setAppSettingsForTeam, async actionMessage => {
    // Initialize the polling for the next update
    FlightSettingsPollingService.initTeamPolling(actionMessage.appSettingsClientModel);
});